import { Component, Input } from '@angular/core';

@Component({
    selector: 'zp-chart-error',
    templateUrl: './chart-error.component.html',
    styleUrls: ['./chart-error.component.scss'],
    standalone: false
})
export class ChartErrorComponent {

    @Input() height = 350;
    @Input() message = 'No results';

}
